import { getUserId } from '../store/features/system';
import { store } from '../store/store';
export var LocalStorageKeys;
(function (LocalStorageKeys) {
    LocalStorageKeys["PRE_INVITE_TOKEN"] = "preInviteToken";
    LocalStorageKeys["SELF_VIDEO_EXPANDED"] = "self-video-expanded";
    LocalStorageKeys["BACKGROUND_EFFECT"] = "background-effect";
})(LocalStorageKeys || (LocalStorageKeys = {}));
export const setLocalStorage = (key, value) => {
    localStorage.setItem(key, value);
};
export const getLocalStorage = (key) => {
    return localStorage.getItem(key);
};
export const removeLocalStorage = (key) => {
    localStorage.removeItem(key);
};
export const getLocalStorageValueForCurrentUser = (key) => {
    const userId = getUserId(store.getState());
    return localStorage.getItem(`${key}:${userId}`);
};
export const setLocalStorageValueForCurrentUser = (key, value) => {
    const userId = getUserId(store.getState());
    localStorage.setItem(`${key}:${userId}`, value);
};
